import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/facebook/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/facebook/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/facebook/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconFacebook24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Facebook logo`, id: 'icon.title.facebook', comment: 'Title for Facebook icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-facebook-24-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" fill-rule="evenodd" d="M23 12.067C23 5.955 18.075 1 12 1S1 5.955 1 12.067C1 17.591 5.023 22.17 10.281 23v-7.734H7.488v-3.199h2.793V9.63c0-2.774 1.643-4.306 4.155-4.306 1.204 0 2.462.216 2.462.216v2.724h-1.387c-1.366 0-1.792.853-1.792 1.728v2.076h3.05l-.487 3.2h-2.563V23C18.977 22.17 23 17.591 23 12.067" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('w-icon-facebook-24')) {
  customElements.define('w-icon-facebook-24', IconFacebook24);
}